export default __webpack_public_path__ + "static/media/graignes18.04a1d4bd.jpg";